module.exports = __webpack_public_path__ + "static/img/logo1 拷贝@2x.bfe3d641.png";